// Ensures only one drag-drop "branch" shows hover chrome at a time.
//
// Holders register themselves on mouseEnter. Ancestors of the deepest hovered
// holder are kept (so leaving a child can restore parent chrome via nestedHoverCount).
// Every other registered holder is force-cleared — this covers cases where
// mouseLeave was skipped (toolbar bridges, scroll) and where a nested child set
// mouseOver without becoming the singleton owner.

let holders = new Map() // id -> { id, element, clear }
let current = null // deepest/latest claim, used by the scroll probe
let scrollListening = false
let lastPointer = { x: 0, y: 0 }
let pointerSeen = false

function ensureScrollProbe() {
    if (scrollListening || typeof window === 'undefined') return
    scrollListening = true
    const onPointerMove = (e) => {
        pointerSeen = true
        lastPointer = { x: e.clientX, y: e.clientY }
    }
    const onScroll = () => {
        if (!holders.size || !pointerSeen) return
        const under = document.elementFromPoint(lastPointer.x, lastPointer.y)
        // Wheel/scroll can move content under a stationary pointer without mouseLeave.
        for (const [id, entry] of [...holders]) {
            const stillContainsPointer = !!(
                entry.element &&
                entry.element.contains &&
                under &&
                entry.element.contains(under)
            )
            if (!stillContainsPointer) {
                holders.delete(id)
                if (current && current.id === id) current = null
                entry.clear()
            }
        }
    }
    window.addEventListener('pointermove', onPointerMove, true)
    document.addEventListener('scroll', onScroll, true)
}

/**
 * @param {object} id Component instance (or other unique token)
 * @param {Element} element Holder DOM node
 * @param {() => void} clear Clears that holder's hover state
 */
export function claimActiveHover(id, element, clear) {
    ensureScrollProbe()
    const entry = { id, element, clear }
    holders.set(id, entry)
    current = entry

    for (const [otherId, other] of [...holders]) {
        if (otherId === id) continue
        // Keep ancestors so parent mouseOver survives while a nested child is hovered.
        const isAncestor = !!(other.element && element && other.element.contains(element))
        if (isAncestor) continue
        holders.delete(otherId)
        if (current && current.id === otherId) current = entry
        other.clear()
    }
}

/**
 * @param {object} id Component instance previously passed to claimActiveHover
 */
export function releaseActiveHover(id) {
    if (holders.has(id)) {
        holders.delete(id)
    }
    if (current && current.id === id) {
        current = null
    }
}
